import React from 'react'
import Swal from 'sweetalert2';

function AlertSmall(message, icon) {
  if (!message) {
    message = "Consulta exitosa"
  }

  if (!icon) {
    icon = "success"
  }
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })


  return (
    //We show a loading alert 
    Toast.fire({
      icon: icon,
      title: message
    })
  )
}

export default AlertSmall